import i18n from '@/utils/i18n';
import React from 'react';
import { BaseActionSheet } from '@/components/base-action-sheet';
import { ItemSortOrder } from '@/contexts/item-context-types';
import { SCREEN_PADDING, TYPOGRAPHY } from '@/styles';
import { SortOrders } from '@/contexts/user-context';
import { SortOrderSelectList } from './sort-order-select-list';
import { StyleSheet, Text, View } from 'react-native';
import { useLayoutContext } from '@/contexts/layout-context';

interface Props<T> {
  buttonRef?: React.RefObject<View | null>;
  isVisible: boolean;
  onChange: (sortOrder: T) => void;
  onClose: () => void;
  supportedSortOptions: T[];
  value: T;
}

export const SortOrderActionSheet = <T extends SortOrders = ItemSortOrder>({
  buttonRef,
  isVisible,
  onChange,
  onClose,
  supportedSortOptions,
  value,
}: Props<T>) => {
  const { isSmallLayout } = useLayoutContext();

  return (
    <BaseActionSheet
      contentStyle={styles.actionSheet}
      isVisible={isVisible}
      onClose={onClose}
      popoverTarget={buttonRef?.current}
    >
      {isSmallLayout ? (
        <Text style={[TYPOGRAPHY.h2, styles.title]}>
          {i18n.t('sort_list_by')}
        </Text>
      ) : null}
      <SortOrderSelectList
        onChange={(nextValue) => {
          onChange(nextValue);
          onClose();
        }}
        supportedSortOptions={supportedSortOptions}
        value={value}
      />
    </BaseActionSheet>
  );
};

const styles = StyleSheet.create({
  actionSheet: {
    paddingHorizontal: 0,
  },
  title: {
    paddingBottom: 8,
    paddingHorizontal: SCREEN_PADDING,
  },
});
